import { Entity, Key } from '@briebug/ngrx-auto-entity';
import { WorkOrderStatus } from '../work-order/work-order.model';

@Entity('WorkOrderCount', { uriName: 'counts' })
export class WorkOrderCount {
  @Key status!: WorkOrderStatus;
  count!: number;
}
